import { Platform } from "react-native";

let loadingElement: HTMLDivElement | null = null;

const createLoadingElement = () => {
  if (typeof document === 'undefined') return null;
  
  const overlay = document.createElement('div');
  overlay.id = 'global-loading-overlay';
  overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: none;
    justify-content: center;
    align-items: center;
    z-index: 999999;
  `;

  const container = document.createElement('div');
  container.style.cssText = `
    background-color: rgba(0, 0, 0, 0.8);
    padding: 20px;
    border-radius: 10px;
    min-width: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `;

  const spinner = document.createElement('div');
  spinner.className = 'loading-spinner';
  spinner.style.cssText = `
    width: 40px;
    height: 40px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  `;

  const text = document.createElement('div');
  text.className = 'loading-text';
  text.style.cssText = `
    color: #fff;
    margin-top: 12px;
    font-size: 14px;
  `;

  // 添加动画样式
  if (!document.getElementById('loading-spinner-style')) {
    const style = document.createElement('style');
    style.id = 'loading-spinner-style';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  container.appendChild(spinner);
  container.appendChild(text);
  overlay.appendChild(container);
  document.body.appendChild(overlay);

  return overlay;
};

export default {
  showLoading(msg: string) {
    showLoading(msg);
  },
  hideLoading() {
    hideLoading();
  },
};

export const showLoading = (msg: string = "加载中...") => {
  if (!loadingElement) {
    loadingElement = createLoadingElement();
  }

  if (loadingElement) {
    const textElement = loadingElement.querySelector('.loading-text') as HTMLDivElement;
    if (textElement) {
      textElement.textContent = msg;
      textElement.style.display = msg ? 'block' : 'none';
    }
    loadingElement.style.display = 'flex';
  }
};

export const hideLoading = () => {

  if (loadingElement) {
    loadingElement.style.display = 'none';
  }
};
